import React from "react";
import { NotFoundTemplate } from "../../Templates/NotFoundTemplate";

export const NotFound = () => {
  return <NotFoundTemplate />;
};
